import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_661e4868-d868-458c-86d6-2d10e12396a2/artifacts/tx0slj8p_ChatGPT_Image_15_de_mai._de_2026__13_56_39-removebg-preview.png";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF9F6] pb-8 relative">
      <img src={LOGO_URL} alt="" className="bg-watermark" />
      
      <div className="app-container relative z-10">
        <header className="flex items-center gap-4 p-4 pt-6">
          <Link to="/" className="p-2 text-[#8E8E93] hover:text-[#2E5C55]">
            <ArrowLeft className="h-6 w-6" />
          </Link>
          <h1 className="font-bold text-xl text-[#1C1C1E]" style={{ fontFamily: 'Syne, sans-serif' }}>
            Termos de Uso
          </h1>
        </header>

        <div className="px-4 prose prose-sm max-w-none">
          <div className="card-base p-6 space-y-4 text-[#48484A]">
            <p className="text-sm text-[#8E8E93]">Última atualização: Janeiro de 2026</p>
            
            <h2 className="text-lg font-bold text-[#1C1C1E]">1. Aceitação dos Termos</h2>
            <p>
              Ao acessar ou usar o aplicativo MapaPodal ("Serviço"), operado por Ad Inteligencia Digital LTDA 
              ("nós", "nosso"), você concorda em estar vinculado a estes Termos de Uso. Se você não concordar 
              com alguma parte dos termos, não poderá acessar o Serviço.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">2. Descrição do Serviço</h2>
            <p>
              O MapaPodal é um aplicativo de bem-estar que utiliza inteligência artificial para fornecer 
              insights educacionais sobre reflexologia podal. O Serviço analisa imagens do solado dos pés 
              para identificar zonas reflexas e fornecer recomendações gerais de bem-estar.
            </p>
            <p className="font-bold text-[#FF9F0A]">
              IMPORTANTE: Este Serviço é EXCLUSIVAMENTE para fins educacionais e de bem-estar. 
              NÃO constitui diagnóstico médico, aconselhamento médico ou tratamento de qualquer condição de saúde.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">3. Conta de Usuário</h2>
            <p>
              Para utilizar o Serviço, você deve criar uma conta fornecendo informações verdadeiras e completas. 
              Você é responsável por manter a confidencialidade de sua senha e por todas as atividades que 
              ocorram em sua conta.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">4. Planos e Pagamentos</h2>
            <p>
              Oferecemos uma leitura gratuita por usuário. Após isso, você pode assinar um de nossos planos 
              mensais. Os pagamentos são processados pelo Mercado Pago e são recorrentes até o cancelamento.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Pack 5 Leituras: R$ 19,90/mês</li>
              <li>Detalhadas 10 Temas: R$ 49,90/mês</li>
              <li>Avançado: R$ 99,00/mês</li>
            </ul>
            <p>
              Você pode cancelar sua assinatura a qualquer momento através do aplicativo. 
              O cancelamento será efetivo ao final do período já pago.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">5. Uso Aceitável</h2>
            <p>Você concorda em não:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Usar o Serviço para qualquer finalidade ilegal</li>
              <li>Enviar imagens que não sejam do solado de pés</li>
              <li>Compartilhar sua conta com terceiros</li>
              <li>Tentar burlar as limitações do sistema</li>
              <li>Fazer engenharia reversa do aplicativo</li>
            </ul>

            <h2 className="text-lg font-bold text-[#1C1C1E]">6. Isenção de Responsabilidade Médica</h2>
            <p className="font-bold">
              O Serviço NÃO substitui consulta médica profissional. Sempre procure orientação de 
              profissionais de saúde qualificados para questões médicas. Nunca ignore ou atrase a 
              busca por aconselhamento médico devido a informações obtidas através deste Serviço.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">7. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo do Serviço, incluindo textos, gráficos, logos e software, é propriedade 
              da Ad Inteligencia Digital LTDA e está protegido por leis de direitos autorais.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">8. Limitação de Responsabilidade</h2>
            <p>
              Em nenhuma circunstância a Ad Inteligencia Digital LTDA será responsável por quaisquer 
              danos indiretos, incidentais, especiais ou consequentes decorrentes do uso do Serviço.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">9. Alterações nos Termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes termos a qualquer momento. Alterações 
              significativas serão comunicadas por email ou através do aplicativo.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">10. Lei Aplicável</h2>
            <p>
              Estes Termos são regidos pelas leis da República Federativa do Brasil. Qualquer 
              disputa será resolvida nos tribunais competentes do Brasil.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">11. Contato</h2>
            <p>
              Para dúvidas sobre estes Termos, entre em contato:
            </p>
            <p>
              <strong>Ad Inteligencia Digital LTDA</strong><br />
              CNPJ: 26.605.304/0001-76<br />
              Email: suporte@adinteligenciadigital.com.br<br />
              FAQ: faq@adinteligenciadigital.com.br
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
